import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { useNewsletterCampaigns } from '../../hooks/useNewsletterCampaigns';
import NewsletterCampaignsTable from './NewsletterCampaignsTable';

const PAGE_CONTENT_SX = {
  py: { xs: 2, md: 3 },
  px: { xs: 2, sm: 3 },
};

function NewsletterCampaignsPage() {
  const { campaigns, loading, error } = useNewsletterCampaigns();

  let body = null;
  if (loading) {
    body = (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    );
  } else if (!error) {
    body = <NewsletterCampaignsTable campaigns={campaigns} />;
  }

  return (
    <DashboardLayout title="Newsletter Campaigns">
      <Box sx={PAGE_CONTENT_SX}>
        <Typography variant="h4" component="h1" gutterBottom>
          Newsletter Campaigns
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Delivery and engagement metrics for I’d Tap That newsletter sends.
          Incomplete metrics are labeled until webhook data settles.
        </Typography>
        {error ? (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error.message}
          </Alert>
        ) : null}
        {body}
      </Box>
    </DashboardLayout>
  );
}

export default NewsletterCampaignsPage;
